module.exports = __webpack_public_path__ + "static/desktop/img/swiper-2-thumb.95847bc7.jpg";